import React, { useEffect, useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getProfile } from "../../redux/reducers/authSlice";
import BasicInfo from "./partials/tabs/BasicInfo";
import Security from "./partials/tabs/Security";
import Subscription from "./partials/tabs/Subscription";
import DeleteAccount from "./partials/tabs/DeleteAccount";


export default function Profile() {
  const [key, setKey] = useState("personal");

  useEffect(() => {
    const getActiveTab = JSON.parse(localStorage.getItem("activeProfileTab"));
    if (getActiveTab) {
      setKey(getActiveTab);
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("activeProfileTab", JSON.stringify(key));
  }, [key]);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getProfile());
  }, [dispatch]);

  const { userDetail, loading } = useSelector((state) => state.auth);

  if (!userDetail && loading) {
    return <div className="p-5 text-center text-muted">Loading Profile...</div>;
  }

  return (
    <div>
      <div className="container mt-5">
        <div className="row">
          <div className="col-12">
            <div className="pageTitle">
              <h1 className="mb-1">Profile</h1>
              <p className="text-muted small fw-medium">Manage your personal information, security settings, and subscription.</p>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="col-12">
          <Tabs
            id="profile-tab"
            className="addBusiness-tab my-4"
            activeKey={key}
            onSelect={(k) => setKey(k)}
          >
            <Tab
              eventKey="personal"
              className="addBusiness-content"
              title="Personal Information"
            >
              <BasicInfo userDetail={userDetail} loading={loading} />
            </Tab>

            <Tab
              eventKey="security"
              className="addBusiness-content"
              title="Security"
            >
              <Security userDetail={userDetail} loading={loading} />
            </Tab>

            <Tab
              eventKey="subscription"
              className="addBusiness-content"
              title="Subscription"
            >
              <Subscription />
            </Tab>


            <Tab
              eventKey="delete-account"
              className="addBusiness-content"
              title="Delete Account"
            >
              <DeleteAccount />
            </Tab>

          </Tabs>
        </div>
      </div>
    </div>
  );
}
